export enum TawreedActionName {
    // Common
    Logout,
    Back,
    Reset,
    ToggleSelection,
    // DashboardComponent
    DashboardCardsSales,
    DashboardCardsOrdersReviewed,
    DashboardCardsOrdersPlaced,
    DashboardCardsOrdersProcessing,
    DashboardCardsOrdersShipped,
    DashboardCardsOrdersReturnShipped,
    DashboardCardsOrdersReadyForDelivery,
    DashboardCardsPartners,
    DashboardCardBalance,
    DashboardChartOrders,
    DashboardChartOrdersTotals,
    DashboardChartOrdersPerZone,
    DashboardChartOrdersPerState,
    DashboardChartPartners,
    // Users
    UsersCreate,
    UsersDetails,
    UsersSubmit,
    UsersDelete,
    DeleteMyAccount,
    UsersChangePassword,
    // Partners
    PartnersCreate,
    PartnersDetails,
    PartnersSubmit,
    PartnersDelete,
    PartnersStoresVerify,
    PartnersCustomersVerify,
    PartnersCustomersCreateWallet,
    PartnersFilesUpload,
    PartnersFilesDownload,
    PartnersCustomersUploadLicenseContentId,
    PartnersCustomersUploadTadeRegisterContentId,
    PartnersCustomersUploadLogo,
    PartnerInformation,
    
    //connections
    PartnerConnectionSetClassification,
    PartnerConnectionRemoveClassification,
    PartnerConnectionAddClassification,

    //Payment partner
    PaymentPartnersCreate,
    PaymentPartnersDetails,
    PaymentPartnersDelete,
    PaymentPartnersSubmit,
    PaymentPartnersActivate,
    PaymentPartnersDeactivate,
    //payment transaction
    PaymentTransactionsDetails,
    //payment orders
    PaymentOrderDetails,
    //Delivery partner
    DeliveryPartnersCreate,
    DeliveryPartnersDetails,
    DeliveryPartnersDelete,
    DeliveryPartnersSubmit,
    DeliveryPartnersActivate,
    DeliveryPartnersDeactivate,
    // Products
    ProductsCreate,
    ProductsDetails,
    ProductsSubmit,
    ProductsDelete,
    // Store-Products
    StoreProductsCreate,
    StoreProductsDetails,
    StoreProductsSubmit,
    StoreProductsDelete,
    StoreProductsActivate,
    StoreProductsDeactivate,
    // Store-Product-Stage
    StoreProductsStageImport,
    StoreProductsDownloadTemplate,
    StoreProductsStageApprove,
    StoreProductsStageReject,
    // Carts
    CartsCreate,
    CartsDetails,
    CartsUpdate,
    CartsStoreCartDelete,
    CartsStoreCartItemDelete,
    // Orders
    OrdersDetails,
    OrdersReturnCreate,
    OrdersConfirm,
    OrdersReview,
    OrdersReadyForDelivery,
    OrdersShip,
    OrdersDeliver,
    OrdersReceive,
    OrdersCancel,
    OrdersReturn,
    OrdersPrintStore,
    OrdersPrintCustomer,
    OrdersEditQuantity,
    OrdersEditBonus,
    OrderEditDiscountValue,
    OrdersEditRetailPrice,
    OrdersEditDiscountPercent,
    OrdersPartnersDetails,
    OrdersPartnersShipAll,
    OrdersPartnersDeliverAll,
    OrdersPartnersReturnAll,
    OrdersPartnersPrintAll,
    OrdersPartnersPrint,
    OrderApplyDiscount,
    // Finance
    FinanceDocumentsCreate,
    //
    ReportsGenerate,

    // zones | stores
    StoreZonesCreate,
    StoreZonesDelete,
    StoreZoneSubmit,
    // zones
    ZonesCreate,
    ZonesDetails,
    ZonesDelete,
    ZonesSubmit,
    //
    ZonesLink,
    ZonesUnlink,
    //
    MarketingCampaign,
    // topup | partners
    TopUpPartnersCreate,
    TopUpPartnersDetails,
    TopUpPartnersSubmit,
    TopUpPartnersDelete,
    TopUpPartnersCleanup,
    // topup | transactions
    TopUpTransactionsDetails,
    //
    WalletTransactionDetails,
    ReportsExport,

    CategoryDetails,
    CategoryNew,
    CategorySubmit,
    CategoryDelete,


    BannerDetails,
    BannerNew,
    BannerSubmit,
    BannerDelete,

    //IMPORTHELPER
    ImpoerHelperDetails,
    ImportUploadTask,
    //store
    StorePartnerSubmit,

    //posts
    PostDetails,
    PostCreate,
    PostSubmit,
    PostDelete,
    PostActivate,
    PostDeactivate,
    OnBoard,

    //topup
    AddCredit,
    
    //store product quantity limitation
    StoreProductQuantityLimitationSubmit,
    StoreProductQuantityLimitationDelete,
    StoreProductQuantityLimitationView
    

}
